var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.68786 1.49999C0.68751 1.42609 0.701925 1.35286 0.73026 1.2846C0.758594 1.21634 0.800275 1.15443 0.852859 1.10249C0.958328 0.997156 1.1013 0.937988 1.25036 0.937988C1.39942 0.937988 1.54239 0.997156 1.64786 1.10249L5.00036 4.45499L8.35286 1.10249C8.45949 1.00313 8.60053 0.949041 8.74625 0.951612C8.89198 0.954183 9.03102 1.01322 9.13408 1.11628C9.23714 1.21934 9.29617 1.35838 9.29874 1.5041C9.30131 1.64983 9.24722 1.79086 9.14786 1.89749L5.39786 5.64749C5.29239 5.75283 5.14942 5.812 5.00036 5.812C4.8513 5.812 4.70833 5.75283 4.60286 5.64749L0.852859 1.89749C0.800275 1.84556 0.758594 1.78365 0.73026 1.71539C0.701925 1.64713 0.68751 1.5739 0.68786 1.49999Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.28791f55450d665bd32a48cd59d8056b.svg";
export { ForwardRef as ReactComponent };